import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";

/**
 * Cohort values for the Copilot email personalization A/B experiment.
 * Centralized so every consumer references the same string literal instead of duplicating it.
 */
export const EmailPersonalizationCohorts = {
    /**
     * Treatment T1 (flag `mon-copilot-email-personalization-t1`) OR the flight
     * `mon-copilot-email-personalization`. The personalization FRE dialog is shown AND
     * personalization is applied while drafting (adds the
     * `vibeWritingWithEmailPersonalizationV3` server variant).
     */
    FREWithPersonalization: "FREWithPersonalization",
    /**
     * Treatment T2 (flag `mon-copilot-email-personalization-t2`). The personalization FRE
     * dialog is shown, but personalization is NOT applied while drafting.
     */
    FREWithoutPersonalization: "FREWithoutPersonalization",
    /**
     * Control (flag `mon-copilot-email-personalization-c`). Neither the FRE dialog is
     * shown nor personalization is applied.
     */
    Control: "Control",
} as const;

export type EmailPersonalizationCohort = (typeof EmailPersonalizationCohorts)[keyof typeof EmailPersonalizationCohorts];

export function getEmailPersonalizationCohort(mailboxInfo: MailboxInfo): EmailPersonalizationCohort | undefined {
    if (isAccountFeatureEnabled("mon-copilot-email-personalization", mailboxInfo) ||
        isAccountFeatureEnabled("mon-copilot-email-personalization-t1", mailboxInfo)) {
        return EmailPersonalizationCohorts.FREWithPersonalization;
    }
    if (isAccountFeatureEnabled("mon-copilot-email-personalization-t2", mailboxInfo)) {
        return EmailPersonalizationCohorts.FREWithoutPersonalization;
    }
    if (isAccountFeatureEnabled("mon-copilot-email-personalization-c", mailboxInfo)) {
        return EmailPersonalizationCohorts.Control;
    }
    return undefined;
}
